import { render } from "./public-holidays.vue?vue&type=template&id=6c806f97&scoped=true"
import script from "./public-holidays.vue?vue&type=script&lang=js"
export * from "./public-holidays.vue?vue&type=script&lang=js"

import "./public-holidays.vue?vue&type=style&index=0&id=6c806f97&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c806f97"]])

export default __exports__